import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Text } from '../components/base/Text';
import { useTheme } from '../hooks';

export const FAQScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useTheme();

  const faqs = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
  ];

  return (
    <div style={{ padding: 'var(--space-lg)' }}>
      <button
        type="button"
        onClick={() => navigate('/')}
        style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-accent)', marginBottom: 'var(--space-lg)' }}
      >
        <ArrowLeft size={20} /> {t('common.back', 'Back')}
      </button>
      <Text variant="display" as="h1" style={{ marginBottom: 'var(--space-lg)', color: 'var(--color-text-primary)' }}>
        {t('faq.title')}
      </Text>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-lg)' }}>
        {faqs.map((faq, i) => (
          <div key={i} style={{ paddingBottom: 'var(--space-lg)', borderBottom: i < faqs.length - 1 ? '1px solid var(--color-border)' : 'none' }}>
            <Text variant="title" style={{ color: 'var(--color-accent)', marginBottom: 'var(--space-xs)' }}>{faq.q}</Text>
            <Text variant="body" muted>{faq.a}</Text>
          </div>
        ))}
      </div>
    </div>
  );
};
